import { render } from "./EmailConfirmed.vue?vue&type=template&id=3fe05393&scoped=true"
import script from "./EmailConfirmed.vue?vue&type=script&lang=js"
export * from "./EmailConfirmed.vue?vue&type=script&lang=js"

import "./EmailConfirmed.vue?vue&type=style&index=0&id=3fe05393&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fe05393"

export default script